module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "complete",
    staticClass: "complete"
  }, [_c('div', {
    staticClass: "titletext"
  }, [_c('h1', [_c('span', {
    staticClass: "icon icon-check_circle"
  }), _vm._v(_vm._s(_vm.$t("completeorder")))])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "data-text"
  }, [_vm._v(_vm._s(_vm.$t("orderid")))]), _vm._v(" "), _c('div', {
    staticClass: "data-index"
  }, [_vm._v(_vm._s(_vm.complete.MiniOrderId))])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {}, [_c('div', {
    staticClass: "details-l"
  }, [_vm._v(_vm._s(_vm.$t("amounts")))]), _vm._v(" "), _c('div', {
    staticClass: "details-r"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("numFilter")(_vm.complete.Total)) + " €")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "details-l"
  }, [_vm._v(_vm._s(_vm.$t("ordersheet")))]), _vm._v(" "), _c('div', {
    staticClass: "details-r"
  }, [_vm._v(_vm._s(_vm.complete.Sheet))])])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "content-oneline",
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "pay"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("backtomain")) + "\n        ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f4d6185","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/complete/complete.vue
// module id = 463
// module chunks = 1